// extracted by mini-css-extract-plugin
export var __company = "footer-module--__company--3b959";
export var __feature = "footer-module--__feature--b7d38";
export var __icon01 = "footer-module--__icon01--0c2cf";
export var __icon02 = "footer-module--__icon02--49460";
export var __icon03 = "footer-module--__icon03--208db";
export var button = "footer-module--button--1df65";
export var copyright = "footer-module--copyright--cfc24";
export var footer = "footer-module--footer--5ef11";
export var footerAddressList = "footer-module--footer-address-list--aa4c3";
export var footerCloudList = "footer-module--footer-cloud-list--f778a";
export var footerCompanyInfo = "footer-module--footer-company-info--b7778";
export var footerFigure = "footer-module--footer-figure--f8a06";
export var footerGlobalList = "footer-module--footer-global-list--d5e72";
export var footerInfoList = "footer-module--footer-info-list--aa7aa";
export var footerLinkList = "footer-module--footer-link-list--e9f9c";
export var footerLogo = "footer-module--footer-logo--0af49";
export var footerNavList = "footer-module--footer-nav-list--30a95";
export var footerNavigation = "footer-module--footer-navigation--3c20e";
export var footerSiteInfo = "footer-module--footer-site-info--d0300";
export var footerSocialIscons = "footer-module--footer-social-iscons--75dd7";
export var footerStatement = "footer-module--footer-statement--02c32";
export var isHidden = "footer-module--is-hidden--18bef";
export var isStack = "footer-module--is-stack--c3740";
export var logoGroup = "footer-module--logo-group--df2d7";
export var logoGroup__svg = "footer-module--logo-group__svg--a6507";
export var navPagetop = "footer-module--nav-pagetop--e2866";